/**************
 Global
 ***************/

const urlParams = new URLSearchParams(window.location.search);

// get index of a specific element
function getElIndex(el) {
    let i;
    for (i = 0; el = el.previousElementSibling; i++) ;
    return i;
}

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    return fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}


//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 } or items: [{ quantity: 1, id: 794864229 }]
function changeProduct(formData) {
    return fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}


// clear cart
function clearCart() {
    return fetch('/cart/clear.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        }
    })

}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
//let formData = {updates: { 794864229: 2, 794864230: 3 }}
function updateCart(formData) {
    return fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}


//download product
function downloadProduct(handle) {
    return fetch(`/products/${handle}.js`)
        .then(function (data) {
            return data.json();
        })
        .then(function (data) {
            return data;
        })
        .catch((error) => {
            return false;
        });
}


// print price (515491 => $5,154.91)
function price(amountInCents, removeTrailingZeros = false) {
    // calculate total
    let total = (parseFloat(amountInCents) / 100).toFixed(2).toString();

    // add commas if needed
    total = total.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // remove trailing zeros
    if (removeTrailingZeros) {
        total = total.toString().replace(".00", "");
    }

    // return total
    return `${currency}${total}`;
}

// sleep
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}


// returns a checkout URL with the current cart items
function getCheckoutURL() {
    if (cart.items.length === 0) {
        console.log("Cart is empty")
        return;
    }

    // initial checkout URL - clear cart first
    let url = "https://" + Shopify.shop + "/cart/clear?return_to=/cart/add?";
    cart.items.forEach(function (item, index) {
        // check for selling plan
        if (item.selling_plan_allocation) {
            url += `items[${index}][quantity]=${item.quantity}%26items[${index}][selling_plan]=${item.selling_plan_allocation.selling_plan.id}%26items[${index}][id]=${item.variant_id}%26`;
        } else {
            url += `items[${index}][quantity]=${item.quantity}%26items[${index}][id]=${item.variant_id}%26`;
        }

    })
    url += "return_to=/checkout"
    console.log(url)
}
